export default {
  START: 'start',
  GAME: 'game'
}
